
export default (axios) => ({
	login(payload) {
		return axios.post("/login", payload)
	},
	getUser() {
		return axios.get("/auth/user")
	}

})